module.exports = __webpack_public_path__ + "img/0Q3A3407_L_Foamcore.1a19f542.jpg";